module.exports = __webpack_public_path__ + "img/InicioSoloCirculosSinFoto.2ba1009d.png";